import { useState } from "react";
import { useNavigate } from "react-router-dom";

const Role = () => {
    const navigate = useNavigate();

    return (
        <>
            <h1 className="section-title">LOG IN TO ACCESS YOUR ACCOUNT BY CHOOSING YOUR ROLE</h1>
            <div className="role-wrapper">
                {/* manager */}
                <div className="role-card">
                    <img src="./images/Union.png" className="role-icon" />
                    <button onClick={() => navigate("/login", { state: { role: "manager" } })}>
                        Manager
                    </button>
                </div>

                {/* emp */}
                <div className="role-card">
                    <img src="./images/employee.png" className="role-icon" />
                    <button onClick={() => navigate("/login", { state: { role: "employee" } })}>
                        Employee
                    </button>
                </div>
            </div>
        </>
    )
}

export default Role;